module.exports = __webpack_public_path__ + "img/Logo-37.c266c901.svg";